<div
  class="compare-selected"
  *ngIf="showSelectedList && showCompareTray"
  role="region"
  [attr.aria-label]="'CFComparison.SelectedProducts' | translate">
  <div class="compare-selected__head">
    <h2 class="compare-selected__title" id="compare-selected-title">
      {{ 'CFComparison.SelectedProducts' | translate }}
    </h2>
    <button type="button" class="compare-selected__clear" (click)="clearAllSelected()">
      {{ 'CFComparison.ClearAll' | translate }}
    </button>
    <button
      type="button"
      class="compare-selected__close"
      [attr.aria-label]="'CFComparison.CloseBar' | translate"
      (click)="closeSelectedList()">
      <i-feather name="x" aria-hidden="true"></i-feather>
    </button>
  </div>
  <div class="compare-selected__list">
    <article class="compare-selected__card" *ngFor="let product of compareProducts">
      <img
        class="compare-selected__image"
        [src]="getDefaultImage(product)"
        [alt]="productLabel(product)"
        (error)="onSlotImageError($event)" />
      <div class="compare-selected__copy">
        <p class="compare-selected__name">{{ productLabel(product) }}</p>
        <p class="compare-selected__price" *ngIf="productPrice(product) as price">{{ price }}</p>
      </div>
      <button
        type="button"
        class="compare-selected__remove"
        [attr.aria-label]="'CFComparison.RemoveProduct' | translate"
        (click)="removeFromCompare($event, product)">
        <i-feather name="x" aria-hidden="true"></i-feather>
      </button>
    </article>
  </div>
</div>

<div
  class="compare-navbar"
  *ngIf="showCompareTray"
  role="region"
  [attr.aria-label]="'CFComparison.CompareProducts' | translate">
  <div class="compare-slots">
    <div class="compare-slot filled" *ngFor="let product of compareProducts">
      <span class="compare-slot__tooltip" role="tooltip">{{ productLabel(product) }}</span>
      <button
        type="button"
        class="slot-remove"
        [attr.aria-label]="'CFComparison.RemoveProduct' | translate"
        (click)="removeFromCompare($event, product)">
        <i-feather name="x"></i-feather>
      </button>
      <img
        [src]="getDefaultImage(product)"
        [alt]="product?.General_Information?.searchKey1 || product?.General_Information?.item || ''"
        (error)="onSlotImageError($event)" />
    </div>
    <button
      type="button"
      class="compare-slot empty"
      *ngFor="let slot of emptySlots"
      [attr.aria-label]="'CFComparison.AddProducts' | translate"
      (click)="goToProductList()">
      <span>+</span>
    </button>
  </div>

  <div class="compare-navbar-copy">
    <p class="slots-left">
      {{ remainingSlots === 0
        ? ('CFComparison.CompareFull' | translate)
        : ((remainingSlots === 1 ? 'CFComparison.SlotLeft' : 'CFComparison.SlotsLeft') | translate:{ count: remainingSlots }) }}
    </p>
    <p class="add-more" *ngIf="compareProducts.length < 2">{{ 'CFComparison.AddOneMore' | translate }}</p>
  </div>

  <button
    type="button"
    class="btn--primary"
    [disabled]="compareProducts.length < 2"
    (click)="goToCompare()">
    {{ 'CFComparison.StartCompareCount' | translate:{ count: compareProducts.length } }}
  </button>

  <button
    type="button"
    class="compare-navbar-close btn--ghost btn--icon"
    [attr.aria-label]="'CFComparison.CloseBar' | translate"
    (click)="closeCompareTray()">
    <i-feather name="x"></i-feather>
  </button>

  <div class="compare-navbar-mobile">
    <div class="compare-navbar-mobile__head">
      <p class="compare-navbar-mobile__count">
        {{ 'CFComparison.SelectedOf' | translate:{ count: compareProducts.length, total: maxProducts } }}
      </p>
      <button type="button" class="compare-navbar-mobile__view" (click)="viewSelected()">
        <span>{{ 'CFComparison.ViewSelected' | translate }}</span>
        <i-feather name="chevron-right" aria-hidden="true"></i-feather>
      </button>
    </div>
    <div class="compare-navbar-mobile__actions">
      <button
        type="button"
        class="btn--primary btn--m"
        [disabled]="compareProducts.length < 2"
        (click)="goToCompare()">
        {{ 'CFComparison.StartCompare' | translate }}
      </button>
      <button type="button" class="btn--ghost btn--m" (click)="closeCompareTray()">
        {{ 'CFComparison.Clear' | translate }}
      </button>
      <div class="compare-navbar-mobile__actions-fill" aria-hidden="true"></div>
    </div>
  </div>
</div>
